// btw-front/src/lib/partnerRepRows.js
// 파트너 정보 수정(PartnerEdit) — 영업대표·기술지원 행 일괄 저장 후 화면 상태 반영.
//
// 저장은 행 단위 요청(create/update/delete)을 한꺼번에 보내므로 일부만 실패할 수 있다.
// 이때 목록을 서버 값으로 다시 불러오면 실패한 행(작성 중인 내용)까지 사라진다.
// → 성공한 행만 서버 상태로 확정하고, 실패한 행은 입력 그대로 남겨 다시 저장할 수 있게 한다.
//   성공한 신규 행을 _new 로 남겨 두면 재저장 시 중복 생성되므로 반드시 id 를 채워 확정한다.

/**
 * 저장 결과를 행 목록에 반영한다.
 * @param rows     현재 행 목록
 * @param outcomes Map<rowKey, { kind: 'create'|'update'|'del', value? }> — 성공한 요청만
 *                 (create 의 value 는 서버 응답 { id })
 * @returns 새 행 목록 — 삭제 성공 행 제거, 생성 성공 행 id 확정, 수정 성공 행 dirty 해제
 */
export function applySavedOutcomes(rows, outcomes) {
  return rows.flatMap((r) => {
    const o = outcomes.get(r.rowKey);
    if (!o) return [r];
    if (o.kind === "del") return [];
    if (o.kind === "create") {
      const id = o.value && o.value.id != null ? String(o.value.id) : r.id;
      return [{ ...r, id, _new: false, _dirty: false }];
    }
    return [{ ...r, _dirty: false }];
  });
}
